import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "@env/environment";

@Injectable({
	providedIn: "root",
})
export class LecteurApiService {
	constructor(private http: HttpClient) {}

	getCpsValidity(assertionCps: string) {
		const headers = new HttpHeaders().set("Content-Type", "application/json");
		return this.http.post(`${environment.apiEmotion()}/pscps/verifyCps`, assertionCps, { headers });
	}
}
